export default __webpack_public_path__ + "static/media/locusofcontrol1Img4.f7754983.png";